import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { StatusEnum } from '@common/constants';
import { resetStoreActions } from '@modules/reset';

import { fetchNews } from './actions';
import { NewsState, NewsType } from './types';

const initialState: NewsState = {
  data: [],
  status: StatusEnum.Uninitialized,
  error: {},
};

export const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchNews.pending.type]: (state: NewsState) => {
      state.status = StatusEnum.Pending;
    },
    [fetchNews.fulfilled.type]: (state: NewsState, action: PayloadAction<NewsType>) => {
      state.status = StatusEnum.Fulfilled;
      state.data = action.payload;
    },
    [fetchNews.rejected.type]: (state: NewsState) => {
      /** TODO-Samanth Accurate Error-Handling */
      state.status = StatusEnum.Rejected;
    },

    ...resetStoreActions(() => initialState),
  },
});

export const newsReducer = newsSlice.reducer;
